import styled from 'styled-components';
import { primary, neutral } from '../../../../style/colors';

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: ${neutral[100]};
  }

  &::-webkit-scrollbar-thumb {
    background: ${neutral[300]};
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    &::-webkit-scrollbar {
      height: 0;
    }
  }
`;

export const NavItem = styled.button`
  appearance: none;
  background: transparent;
  border: 0;
  border-bottom: 3px solid ${props => props.$active ? primary[500] : 'transparent'};
  font-family: inherit;
  font-size: 14px;
  color: ${props => props.$active ? primary[500] : neutral[500]};
  font-weight: ${props => props.$active ? '600' : '500'};
  cursor: pointer;
  padding: 16px 24px;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    color: ${primary[500]};
    background: ${neutral[50]};
  }

  &:focus-visible {
    outline: 2px solid ${primary[500]};
    outline-offset: -4px;
  }

  @media (max-width: 768px) {
    padding: 12px 16px;
    font-size: 13px;
  }
`;
